export const isMockDataActive = false;


// WEBPACK FOOTER //
// ./src/mundial/requests/mockData/isMockDataActive.ts